// extracted by mini-css-extract-plugin
export var fadeInOut = "_14-3";
export var icon = "_14-4";
export var savedIndicator = "_14-2";
export var savingIndicator = "_14-0";
export var spin = "_14-1";